import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconQualityStyle0 = cosmosIconCss;

const CosmosIconQuality$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconQuality extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f056685c82a91ff21bd2fc1f6b3a122e06ea42fe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fb6b66e118d4d3b0bef3654d95b82cfd134d802b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9638531f42e5fafa26c1c476cb3d5f51855514fd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.051 7.859a.5.5 0 0 0 .069-.593l-1.174-2.032A.5.5 0 0 0 16.4 5l-2.477.586a6.222 6.222 0 0 0-1.368-.786l-.732-2.439A.5.5 0 0 0 11.344 2H9a.5.5 0 0 0-.479.356L7.786 4.8a6.148 6.148 0 0 0-1.362.789L3.945 5a.5.5 0 0 0-.549.237L2.223 7.266a.5.5 0 0 0 .069.593l1.745 1.854a6.484 6.484 0 0 0 0 1.575l-1.745 1.853a.5.5 0 0 0-.069.593L3.4 15.766a.5.5 0 0 0 .544.234l1.671-.395A.5.5 0 0 0 6 15.122v-3.357a4.131 4.131 0 0 1 .332-3.674 4.382 4.382 0 0 1 8.182 1.465c.032.25.242.44.494.444h1.076a.5.5 0 0 0 .389-.186l1.578-1.955Z", fill: "currentColor" }), h("path", { key: '72bbab0e6f6a142672c0abfad4375b26d9379d65', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 12h-11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", fill: "#DB0A40" }), h("path", { key: 'aa7117ed07707642f3a5026e0216d4f2918b9108', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.557 17.955a.264.264 0 0 1-.277.288h-.733a.264.264 0 0 1-.277-.288v-1.431h-1.232v1.431a.264.264 0 0 1-.277.288h-.732a.264.264 0 0 1-.278-.288V14.05a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v1.31h1.232v-1.31a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v3.906Zm1.154.288h1.566a2.3 2.3 0 0 0 2.473-2.263 2.254 2.254 0 0 0-2.474-2.22H14.71a.265.265 0 0 0-.277.29v3.905a.264.264 0 0 0 .277.288Zm1.022-3.317h.544a1.01 1.01 0 0 1 1.12 1.054 1.038 1.038 0 0 1-1.12 1.098h-.544v-2.152Z", fill: "#fff" }))));
    }
    static get style() { return CosmosIconQualityStyle0; }
}, [1, "cosmos-icon-quality", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-quality"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-quality":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconQuality$1);
            }
            break;
    } });
}

const CosmosIconQuality = CosmosIconQuality$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconQuality, defineCustomElement };
